import * as React from 'react';
import {useEffect} from 'react';
import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import reicon from '../../assets/main/reicon.png';
import counsel from '../../assets/main/counsel.png';
import center from '../../assets/main/center.png';
import {useNavigate} from "react-router-dom";
import * as util from "../../utils/util";
import api from "../../utils/api";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Skeleton from '@mui/material/Skeleton';

type ReservationItem = {
  famGrade: string, firstWishDate: string, ipDate: string, hoName: string,
  famName: string, rsvName: string, hoImage: string, rsvId: string,
  reservationStatus: { code: number, name: string }, reservationTime: string,
};

// 예약 시간(HHmm) 포맷 - 값이 없으면 빈 문자열
function getReservationTimeText(reservationTime: any) {
  const time = util.strNull(reservationTime);
  if (time.length < 3) {
    return '';
  }
  return time.slice(0, -2) + ':' + time.slice(-2);
}

const MainMedical = () => {

  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  // 초기값을 빈 배열로 두어야 예약이 없을 때 빈 카드가 그려지지 않음
  const [reservationList, setReservationList] = React.useState<ReservationItem[]>([]);

  useEffect(() => {

    setLoading(true);
    // 예약 목록
    if (util.strNull(window.localStorage.userCusID) !== '') {
      api.post('customer/api/v1/CU_004_001', { cusId: window.localStorage.userCusID }).then((res: any) => {
        const nowYear = new Date().getFullYear().toString();

        const counsel: any[] = res.data.counsel || [];
        const filteredData = counsel.filter((v: any) => v.reservationStatus.code >= 0
        && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear));
        const maxCount = Math.max(...filteredData.map((v: any) => v.count)); // 마지막 차수 예약만 노출
        setReservationList(filteredData.filter((v: any) => v.count === maxCount));

        // setReservationList(res.data.counsel.filter((v: any) => v.reservationStatus.code >= 0
        //   && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear))); // 해당연도 && 예약대기, 예약확정, 수진완료, 결과등록 데이터만 출력

        setLoading(false);
      }).catch(function (error: any) {
        console.log(error)
        setReservationList([]);
        setLoading(false);
      });
    }else{
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, []);



  return (
    <React.Fragment>


      <List sx={{ width: '100%', p: '5px 0', bgcolor: '#fff', borderRadius: '20px', mt: 0, mb: 2 }}
        onClick={() => util.strNull(window.localStorage.userCusID) === '' || reservationList.length < 1 ? navigate('../reservationCounsel') : {}}>
        <ListItem alignItems="center" >

          <Stack sx={{ width: '100%', }}>

            <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
              <Box sx={{ bgcolor: '#FEF8F5', width: 64, height: 64, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {loading ? (
                  <Skeleton animation="wave" variant="circular" width={64} height={64} />
                ) : (
                  <Avatar alt="" src={counsel} sx={{ borderRadius: 0 }} />
                )}
                {/* Skeleton */}
              </Box>

              {loading ? (
                <Stack direction={'column'} sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', width: '50%' }} justifyContent='center' alignContent={'center'}>
                  <Skeleton animation="wave" variant="rounded" height={21} width='100%' sx={{ borderRadius: 3, }} />
                  <Skeleton animation="wave" variant="rounded" height={21} width='100%' sx={{ borderRadius: 3, my: 1 }} />
                </Stack>
              ) : (
                <Stack direction={'column'}>
                  <Typography sx={{ fontSize: 14, color: '#666' }}>심리상담 편리하게 예약하기</Typography>
                  <Typography sx={{ fontSize: 18, fontWeight: 700, m: '5px 0', color: '#555' }}>심리상담 예약</Typography>
                </Stack>
              )}
              {/* Skeleton */}
            </Stack>



            {util.strNull(window.localStorage.userCusID) === '' || reservationList.length < 1 ? (
              <Box>
                {loading ? (
                <Stack direction={'column'} sx={{ display: loading ? 'flex' : 'none', width: '80%',mx:'auto' }} justifyContent='center' alignItems={'center'}>
                  <Skeleton animation="wave" variant="rounded" height={21} width='100%' sx={{ borderRadius: 3, }} />
                </Stack>
              ) : (
              <Stack direction={'row'} justifyContent={'center'} onClick={() => navigate('/reservationCounsel')}>
                <EventBusyIcon sx={{ fontSize: 18, color: '#aaa', m: '3px 10px 0 0' }} />
                <Typography sx={{ fontSize: 14, color: '#EF8322' }}>예약 정보가 없습니다</Typography>
              </Stack>
              )}
              </Box>
            ) : (

              reservationList.slice(0, 5).map((item, index) => (
                <Box>
                  {loading ? (
                    <Box sx={{ display: loading ? 'flex' : 'none', textAlign: 'center', }} justifyContent='center' alignContent={'center'}>
                      <Skeleton animation="wave" variant="rounded" height={95} width="100%" sx={{ borderRadius: 3, }} />
                    </Box>
                  ) : (
                    <Stack className='reservationList' direction={'column'} justifyContent={'center'}
                      sx={{
                        p: 0,
                        bgcolor: '#f9f9f9',
                        borderRadius: 3,
                        mt: 1,
                        '&.reservationList:nth-child(n+1)': { py: 1, px: 2 },

                      }}
                      onClick={() => navigate('/reservation/SetFinishDetail', { state: { hoImage: item.hoImage, rsvId: item.rsvId, url: 'ReservationView' } })}>

                      <Stack direction={'row'} >
                        <PersonOutlineOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '3px 10px 0 0', }} />
                        <Typography sx={{ fontSize: 16, color: '#777', mt: '0px', fontWeight: 700 }}>{item.famName}
                          {util.strNull(item.famGrade) !== '' ? (
                            <Typography component={'span'} sx={{ fontSize: 14, color: '#555', mt: '2px', ml: .5 }}>{'(' + item.famGrade + ')'}</Typography>
                          ) : null}
                        </Typography>
                      </Stack>
                      <Stack direction={'row'} my={.5}>
                        <EventAvailableOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '4px 10px 0 0' }} />
                        <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#ff666c' }}>
                          {util.strNull(item.ipDate) !== '' ? item.ipDate : item.firstWishDate} {getReservationTimeText(item.reservationTime)}
                        </Typography>
                        {util.strNull(item.reservationStatus.name) === '' ? null : item.reservationStatus.code <= 0 ? (
                          <Chip label={item.reservationStatus.name} size="small" sx={{ ml: 2, verticalAlign: 'top', bgcolor: '#f18322', color: '#fff', }}></Chip>
                        ) : (
                          <Chip label={item.reservationStatus.name} size="small" variant="outlined" sx={{ ml: 2, verticalAlign: 'top', bgcolor: '#fff', color: '#f18322', borderColor: '#f18322' }}></Chip>
                        )}
                      </Stack>

                      <Stack direction={'row'}>
                        <LocalHospitalOutlinedIcon sx={{ fontSize: 18, color: '#aaa', m: '4px 10px 0 0' }} />
                        <Typography sx={{ fontSize: 14, color: '#555', mt: '2px' }}> {item.hoName}</Typography>
                      </Stack>

                    </Stack>
                  )}  {/* Skeleton */}
                </Box>

              )
              ))}
          </Stack>

        </ListItem>
      </List>

    </React.Fragment>

  );
}

export default MainMedical;